/**
 * IntersectionObserver is not supported in JSDOM, can't really test it.
 *
 * TODO: Make a mock for it?
 */
/* istanbul ignore file */

import * as React from 'react';

type VisibilityTrackerProps = {
    onContentVisible: Function;
    options?: IntersectionObserverInit;
    elementRef: { current: HTMLElement | null };
};

export class VisibilityTracker extends React.Component<VisibilityTrackerProps> {
    static defaultProps = { onContentVisible: () => {} };

    constructor(props: VisibilityTrackerProps) {
        super(props);

        this.observer = null;
        this.handleIntersections = this.handleIntersections.bind(this);
    }

    componentDidMount(): void {
        this.initObserver();
    }

    componentDidUpdate(): void {
        if (!this.observer) {
            this.initObserver();
        }
    }

    componentWillUnmount(): void {
        this.disconnectObserver();
    }

    initObserver(): void {
        if (this.props.elementRef.current) {
            this.observer = new IntersectionObserver(
                this.handleIntersections,
                this.props.options || {}
            );
            this.observer.observe(this.props.elementRef.current);
        }
    }

    handleContentVisibility(): void {
        this.props.onContentVisible();
        this.disconnectObserver();
    }

    disconnectObserver(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    observer: IntersectionObserver | null;

    handleIntersections(entries: IntersectionObserverEntry[]): void {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.handleContentVisibility();
            }
        });
    }

    render(): React.ReactNode {
        return null;
    }
}
